import * as React from 'react';
import Profile from 'src/models/Profile';
import GeneratorEntity from '../../../../../models/Generator';
import GeneratorCard from './GeneratorCard';

interface IProps {
  generators: GeneratorEntity[]
  showDragUi: boolean

  delete: (generator: GeneratorEntity) => void
  run: (generator: GeneratorEntity) => void
  validator: (generator: GeneratorEntity) => void
  profile: Profile
  download: (gen: GeneratorEntity) => void
  openTokenModalForGenerator: (gen: GeneratorEntity) => void;
}

export const CardView: React.SFC<IProps> = props => {

  return (
    <>
      {props.generators.map( (gen) => {
        return <GeneratorCard 
                  showDragUi={props.showDragUi} 
                  generator={gen} key={gen.id} 
                  validator={props.validator} 
                  profile={props.profile} 
                  delete={props.delete} 
                  run={props.run} 
                  download={props.download}
                  openTokenModalForGenerator={props.openTokenModalForGenerator}
                  />
      })}
    </>
  )
};



// WEBPACK FOOTER //
// ./src/Containers/generators/GeneratorList/GeneratorView/CardView/index.tsx